
<div class="modal-overlay">
    <div class="modal-container">
        <div class="modal-header">
            <div class="title-wrapper">
                <h2>Directory Information Required</h2>
                <p class="subtitle">Complete/Update the following directory information based on your practice location.</p>
            </div>
            <button class="close-btn" (click)="onCancel()">×</button>
        </div>
 
        <div class="modal-body">
            <table class="directory-table">
                <tbody>
                    <!-- Weekend Hours -->
                    <tr>
                        <td class="question-col">Does your practice have weekend hours? <span class="clr-red" *ngIf="weekendForm.controls['weekendHours'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Does your practice have weekend hours?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="weekendForm"  [label]="''" [for] = "'weekend-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="weekendHours">
                                       </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(weekendForm, 'weekendHours')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Morning Hours -->
                    <tr>
                        <td class="question-col">Does your practice have morning hours before 8 am? <span class="clr-red"
                            *ngIf="morningHoursForm.controls['morningHours'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Does your practice have morning hours before 8 am?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="morningHoursForm"  [label]="''" [for] = "'morning-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="morningHours">
                                       </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(morningHoursForm, 'morningHours')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Evening Hours -->
                    <tr>
                        <td class="question-col">Does your practice have evening hours after 5 pm? <span class="clr-red"
                            *ngIf="eveningHoursForm.controls['eveningHours'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Does your practice have evening hours after 5 pm?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="eveningHoursForm"  [label]="''" [for] = "'evening-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="eveningHours">
                                       </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(eveningHoursForm, 'eveningHours')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Emergency Phone -->
                    <tr>
                        <td class="question-col">Do you have an emergency out-of-office phone number that is different
                            than your main number? <span class="clr-red"
                            *ngIf="emergencyNumberForm.controls['emergencyPhone'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Do you have an emergency out-of-office phone number that is different than your main number?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="emergencyNumberForm"  [label]="''" [for] = "'phone-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="phone" (changed)="validatePhone()">
                                        </app-radio> 
                                    </div>
                                </fieldset>
                                <app-text-input class="phn-label" *ngIf="emergencyNumberForm.get('emergencyPhone')?.value == 'yes'" [for] = "'phoneNumber-Input'" [placeholder]="'Enter'"
                                [control]="directoryFormGroup.controls['phoneNumber']" appPhoneMask></app-text-input>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(emergencyNumberForm, 'emergencyPhone')">Required</div>
                            <div class="directory-validator" *ngIf="hasPhoneRequiredError()">Required</div>
                        </td>
                    </tr>
 
                    <!-- Public Transit -->
                    <tr>
                        <td class="question-col">Is there public transit accessibility near your practice? <span class="clr-red"
                            *ngIf="publicTransitForm.controls['publicTransit'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Is there public transit accessibility near your practice?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="publicTransitForm"  [label]="''" [for] = "'transit-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="transit">
                                        </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(publicTransitForm, 'publicTransit')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Disabled Adults -->
                    <tr>
                        <td class="question-col">Do you provide care to disabled adults? <span class="clr-red"
                            *ngIf="disabledAdultsForm.controls['disabledAdults'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Do you provide care to disabled adults?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="disabledAdultsForm"  [label]="''" [for] = "'adults-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="adults">
                                       </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(disabledAdultsForm, 'disabledAdults')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Disabled Children -->
                    <tr>
                        <td class="question-col">Do you provide care to disabled children? <span class="clr-red"
                            *ngIf="disabledChildrenForm.controls['disabledChildren'].errors">*</span></td>
                        <td class="answer-col">
                            <div class="answer-wrapper">
                                <fieldset class="radio-fieldset">
                                    <legend class="sr-only">Do you provide care to disabled children?</legend>
                                    <div class="radio-group">
                                        <app-radio layout="horizontal" [formGroup]="disabledChildrenForm"  [label]="''" [for] = "'children-Input'" 
                                        [options]="[{value: 'yes', label: 'Yes'}, {value: 'no', label: 'No'}]" id="children">
                                       </app-radio> 
                                    </div>
                                </fieldset>
                            </div>
                            <div class="directory-validator" *ngIf="hasRequiredError(disabledChildrenForm, 'disabledChildren')">Required</div>
                        </td>
                    </tr>
 
                    <!-- Languages -->
                    <tr>
                        <td class="question-col">Other than English, what other languages are spoken?</td>
                        <td class="answer-col">
                            <app-text-input [label]="''" [for] = "'language-Input'" [placeholder]="'Enter'"
                            [control]="directoryFormGroup.controls['languages']"></app-text-input>
                        </td>
                    </tr>
 
                    <!-- Website -->
                    <tr>
                        <td class="question-col">What is your practice's full website address?</td>
                        <td class="answer-col">
                            <app-text-input [label]="''" [for] = "'website-Input'" [placeholder]="'Enter'"
                            [control]="directoryFormGroup.controls['website']"></app-text-input>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
 
        <div class="modal-footer">
            <button class="btn btn-outline cancel-btn" (click)="onCancel()">Cancel</button>
            <button class="btn-submit" (click)="onSubmit()" [disabled]="impersonatedUser">Submit</button>
        </div>
    </div>
</div>